import { tvFeatures } from "@/mocks/tvVersions";
import SectionHeading from "./SectionHeading";

export default function TvSection() {
  return (
    <section id="tv" className="section-anchor w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-7xl mx-auto">
          <SectionHeading
            eyebrow="电视剧版"
            title="潘金莲电视剧版的特点与观看方向"
            desc="电视剧版与电影最大的不同在于篇幅。更长的体量让支线人物、家庭关系和市井环境都有机会被完整呈现，也因此形成了差异化的观看体验。"
          />

          <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-1 order-2 lg:order-1">
              <div className="w-full h-[240px] lg:h-full lg:min-h-[420px] rounded-lg overflow-hidden border border-background-200/70">
                <img
                  src="https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20painting%20of%20a%20traditional%20two%20story%20residence%20with%20wooden%20balcony%20and%20hanging%20lanterns%20at%20dusk%2C%20warm%20paper%20texture%2C%20muted%20vermillion%20and%20gold%20tones%2C%20quiet%20drama%20atmosphere%2C%20no%20text&width=900&height=1200&seq=pjl-tv&orientation=portrait"
                  alt="水墨风格的两层宅院与灯笼，呼应电视剧中的宅院环境"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:col-span-2 order-1 lg:order-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {tvFeatures.map((f) => (
                <article
                  key={f.id}
                  className="rounded-lg bg-background-100 border border-background-200/70 p-5"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${f.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {f.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                    {f.desc}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}